import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"80px"} }

import { reactive, onMounted, onUnmounted } from 'vue';
import { useApolloClient } from '@vue/apollo-composable';
import { getServiceList, getSpecialistServiceList } from "@/utils/graphql";
import { scrollTop } from "@/utils/functions";
import DesktopNavbar from './DesktopNavbar.vue';
import MobileNavbar from './MobileNavbar.vue';

interface Service {
  displayText: string;
  path: string;
  serviceType: {
    contentItems: {
      displayText: string;
    }[];
  };
  showOnHomePage?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const { resolveClient } = useApolloClient();

const state = reactive({
  isScrolled: false,
  isDesktop: window.innerWidth >= 992,
  homeServices: [] as any[],
  groupedServices: {} as Record<string, any[]>,
  specialistServices: [] as any[],
});

const groupServicesByType = (services: Service[]) => {
  const grouped: Record<string, Service[]> = {};
  if (!services) return grouped;
  services.forEach(service => {
    if (service.serviceType?.contentItems) {
      service.serviceType.contentItems.forEach(type => {
        const typeName = type.displayText;
        if (!grouped[typeName]) {
          grouped[typeName] = [];
        }
        grouped[typeName].push(service);
      });
    }
  });
  return grouped;
};

const handleScroll = () => {
  state.isScrolled = window.scrollY > 50;
};

const handleResize = () => {
  state.isDesktop = window.innerWidth >= 992;
};

const homeScroll = () => {
  if (window.scrollY !== 0) {
    setTimeout(() => scrollTop(''), 50);
  }
};

onMounted(async () => {
  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll);

  try {
    const ApolloClient = resolveClient();
    const [servicesData, specialistServicesData] = await Promise.all([
      getServiceList(ApolloClient),
      getSpecialistServiceList(ApolloClient)
    ]);

    if (servicesData) {
      state.homeServices = servicesData;
      state.groupedServices = groupServicesByType(servicesData);
    }

    if (specialistServicesData) {
      state.specialistServices = specialistServicesData;
    }

  } catch (error) {
    console.error("Failed to load navigation data:", error);
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.isDesktop)
      ? (_openBlock(), _createBlock(DesktopNavbar, {
          key: 0,
          "is-scrolled": state.isScrolled,
          "grouped-services": state.groupedServices,
          "specialist-services": state.specialistServices,
          onHomeScroll: homeScroll
        }, null, 8, ["is-scrolled", "grouped-services", "specialist-services"]))
      : (_openBlock(), _createBlock(MobileNavbar, {
          key: 1,
          "is-scrolled": state.isScrolled,
          "home-services": state.homeServices,
          "specialist-services": state.specialistServices,
          onHomeScroll: homeScroll
        }, null, 8, ["is-scrolled", "home-services", "specialist-services"]))
  ]))
}
}

})